// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.input-select-button {
  background-color: var(--color-input-background);
  color: var(--color-content-base);
  box-shadow: 0 0 0 1px var(--color-border-base), 0px -1px 1px var(--color-border-base);
  line-height: 32px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  border: none;
  height: 32px;
  cursor: pointer;
  justify-content: space-between;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  padding: 6px 8px;
  display: flex;
  align-items: center;
}
.input-select-button--disabled {
  opacity: 0.5;
}
.input-select-button--plain {
  box-shadow: none;
}
.input-select-button--hide-arrows::-webkit-outer-spin-button,
.input-select-button--hide-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Chrome & Safari */
}
.input-select-button--hide-arrows[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}
.input-select-button--error {
  box-shadow: 0 0 0 1px var(--color-error-shadow-base), 0px -1px 1px var(--color-error-shadow-base);
  background-color: var(--color-error-background-base);
}
.input-select-button--variant-small {
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
}
.input-select-button--variant-medium {
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
}
.input-select-button--variant-large {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
}
.input-select-button--focused,
.input-select-button:focus {
  outline-offset: 2px;
  outline: 2px solid var(--color-outline-base);
}
.input-select-button[data-placeholder] {
  color: var(--color-content-secondary);
}
.input-select-button__icon {
  color: var(--color-content-secondary);
}
.input-select-button__content {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-align: start;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.input-select-button__icon {
  flex-shrink: 0;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/input-select/InputSelectButton.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/input.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/misc.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;ECCE,+CAAA;EACA,gCAAA;EACA,qFAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EAyDA,eAAA;EAIA,8BAAA;EACA,WAAA;EAEA,yBAAA;UAAA,iBAAA;EAEA,gBAAA;EDxEA,aAAA;EACA,mBAAA;AAqBF;ACVE;EACE,YAAA;ADYJ;ACTE;EACE,gBAAA;ADWJ;ACPI;;EAEE,wBAAA;EDSJ,oBAAoB;AACtB;ACPI;EACE,0BAAA;EDSJ,YAAY;AACd;ACNE;EACE,iGAAA;EACA,oDAAA;ADQJ;ACLE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADOJ;ACJE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADMJ;ACHE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADKJ;ACFE;;EC1DA,mBAAA;EACA,4CAAA;AFgEF;ACaE;EACE,qCAAA;ADXJ;ACcE;EACE,qCAAA;ADZJ;AAhEE;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AAkEJ;AA/DE;EACE,cAAA;EACA,qBAAA;AAiEJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.input-select-button {\n  .neptune-input-select();\n\n  display: flex;\n  align-items: center;\n\n  &__content {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-align: start;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  &__icon {\n    flex-shrink: 0;\n    display: inline-block;\n  }\n}\n","@import \"./../variables.less\";\n\n.neptune-input(@with-padding: true) {\n  background-color: var(--color-input-background);\n  color: var(--color-content-base);\n  box-shadow: @input-box-shadow;\n  line-height: 32px;\n  font-size: @fontSize-sm;\n  font-weight: @fontWeight-regular;\n  border-radius: @input-border-radius;\n  border: none;\n  height: 32px;\n\n  & when (@with-padding = true) {\n    padding: 0 5px;\n  }\n\n  &--disabled {\n    opacity: 0.5;\n  }\n\n  &--plain {\n    box-shadow: none;\n  }\n\n  &--hide-arrows {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none; /* Chrome & Safari */\n    }\n\n    &[type=number] {\n      -moz-appearance: textfield; /* Firefox */\n    }\n  }\n\n  &--error {\n    box-shadow: @input-box-shadow-error;\n    background-color: @input-bg-error;\n  }\n\n  &--variant-small {\n    height: @layoutUnit-lg;\n    line-height: @layoutUnit-lg;\n    border-radius: 4px;\n  }\n\n  &--variant-medium {\n    height: @layoutUnit-xl;\n    line-height: @layoutUnit-xl;\n    border-radius: 4px;\n  }\n\n  &--variant-large {\n    height: @layoutUnit-xxl;\n    line-height: @layoutUnit-xxl;\n    border-radius: 4px;\n  }\n\n  &--focused,\n  &:focus {\n    .n-outline();\n  }\n}\n\n.neptune-input-select() {\n  .neptune-input(@with-padding: false);\n\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  user-select: none;\n\n  padding: 6px 8px;\n\n  &[data-placeholder] {\n    color: var(--color-content-secondary);\n  }\n\n  &__icon {\n    color: var(--color-content-secondary);\n  }\n}\n",".n-outline() {\n  outline-offset: 2px;\n  outline: 2px solid var(--color-outline-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
